import { lazy, Suspense } from 'react';

const ResetPasswordForm = lazy(() =>
  import('@repo/ui/components/containers/login/reset-password-form').then((mod) => ({ default: mod.default })),
);

export default function ResetPasswordPage() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
      <ResetPasswordForm />
    </Suspense>
  );
}
